/* This is the Climate Change Component N.10 - primary and secondary school  */

<template>
  <v-container>
    <div>
      <strong>
        <span v-html="title"></span>
      </strong>
    </div>
    <div>
      <table
        style="height: 43px"
        width="800px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              សម្ភារសិក្សា
            </td>
            <td class="row-data">{{ gradeLabel[0] }}</td>
            <td class="row-data">{{ gradeLabel[1] }}</td>
            <td class="row-data">{{ gradeLabel[2] }}</td>
            <td class="row-data">{{ gradeLabel[3] }}</td>
            <td class="row-data">{{ gradeLabel[4] }}</td>
            <td class="row-data">{{ gradeLabel[5] }}</td>
          </tr>
          <tr v-for="(value, row) in material_demage.length" :key="row">
            <td
              style="
                width: 200px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ material_demage[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].d.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].d[col]" class="number" />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { material_demage } from "@/utils/ascf/climateVariables.js";
import { priLevel } from "@/utils/ascf/priConfig.js";
import { secLevel } from "@/utils/ascf/secConfig.js";

import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "type_code", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      material_demage: material_demage,
      priLevel: priLevel,
      secLevel: secLevel,
    };
  },
  computed: {
    gradeLabel: function () {
      if (this.type_code === 2) {
        return this.priLevel;
      } else if (this.type_code > 2) {
        return this.secLevel;
      } else {
        return null;
      }
    },
  },
};
</script>
<style scoped>
.number {
  width: 100px;
  text-align: center;
}
.row-data {
  width: 100px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
</style>